/* eslint-disable @typescript-eslint/no-explicit-any */
// COPIED FROM suite/core: node_modules\@costar-suite\core\src\utilities\last-promise.ts

/**
 * Function for creating a filter function that tracks the promise provided in the most recent call.
 * This can be used to tag multiple requests to the same endpoint such that only the most recent
 * promise is not tagged as stale.
 */
var lastPromise = function lastPromise() {
  var latestPromise;

  /**
   * Function accepting a that transforms to the promise result to indicate whether this function has been
   * called more recently with a different promise. `isStale` will be true if this function has been passed
   * a promise more recently.
   *
   * @param promise
   * @return {{result, isStale}}
   */
  return function (promise) {
    if (!promise) {
      throw new Error('promise parameter is required');
    }
    latestPromise = promise;
    return promise.then(function (result) {
      return {
        result: result,
        isStale: latestPromise !== promise
      };
    });
  };
};

export { lastPromise };
//# sourceMappingURL=last-promise.esm.js.map
